module.exports = __webpack_public_path__ + "img/f725658.jpg";